import React, { useEffect, useState } from "react";
import { pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import { useMsal } from "@azure/msal-react";
import { getAccessToken, fetchData } from '../common/MSALHelper.js'
import ButtonSpinner from "./ButtonSpinner.js";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export default function PrintTaxReceipt({ pdfUrl }) {
    const { instance, accounts } = useMsal();

    // const [numPages, setNumPages] = useState(null);
    // const [pageNumber, setPageNumber] = useState(1);

    const [yearbuttons, setYearbuttons] = useState(null);

    const [isLoadingButtonStates, setIsLoadingButtonStates] = useState({});

    // const onLoadSuccess = ({ numPages }) => {
    //     setNumPages(numPages);
    //     console.log(`PDF loaded successfully with ${numPages} pages`)

    //     handleTextReplace();
    //     console.log("Called handleTextReplace");
    // };

    useEffect(() => {
        //get years for the Receipts
        getAccessToken(instance, accounts).then(response => {
            fetchData(response, '/receipt_yearcount', res => {
                if (!res.ok)
                    throw new Error(`HTTP error! status: ${res.status}`);

                return res.json();
            }, data => {
                setYearbuttons(data);
                data.forEach(x => {
                    setIsLoadingButtonStates((prevStates) => ({
                        ...prevStates,
                        [`receipt_${x.Year}_button`]: false,
                        [`thankyou_${x.Year}_button`]: false,
                        [`label_${x.Year}_button`]: false
                    }));
                });
            })
        })
    }, [instance, accounts])

    // const handleTextReplace = async () => {
    //     // Load the PDF document
    //     const pdfDocument = await pdfjs.getDocument(pdfUrl).promise;

    //     // Iterate over each page
    //     for (let pageNum = 1; pageNum <= numPages; pageNum++) {
    //         // Get the page text
    //         const page = await pdfDocument.getPage(pageNum);
    //         const pageText = await page.getTextContent();

    //         // Iterate over each text item on the page
    //         for (let i = 0; i < pageText.items.length; i++) {
    //             const textItem = pageText.items[i];
    //             console.log(textItem.str);

    //             const nameValue = "Lan Tran";
    //             // Check if the text matches the target
    //             if (textItem.str.includes(nameValue)) {
    //                 // Find the starting and ending indices of "Lan Tran"
    //                 const startIndex = textItem.str.indexOf(nameValue);
    //                 const endIndex = startIndex + nameValue.length;
                  
    //                 // Replace the text with the desired value
    //                 textItem.str = textItem.str.substring(0, startIndex) + "{name}" + textItem.str.substring(endIndex);
    //               }
    //         }
    //     }

    //     // Render the modified PDF
    //     // Note: This will render the entire PDF again, including all pages
    //     setPageNumber(1);
    // };

    // const download_file = () => {
    //     getAccessToken(instance, accounts).then((response) => {
    //         let accessToken = response;
    //         const ids = [10000];
    //         const idString = ids.join(',');
    //         fetchData(accessToken, `/download_receipt?ids=${idString}`, response => {
    //             if (!response.ok)
    //                 throw new Error(`HTTP error! status: ${response.status}`);

    //             return response.blob();
    //         }, data => {
    //             const blob_data = data;
    //             console.log(blob_data);

    //             // Create a downloadable link
    //             // Create a blob URL for the blob
    //             const blobUrl = URL.createObjectURL(blob_data);
    //             const link = document.createElement('a');
    //             link.href = blobUrl;
    //             link.download = 'tax_receipts.pdf'; // Set default filename if not provided

    //             // Trigger the download
    //             link.click();

    //             // Cleanup the temporary URL (optional)
    //             setTimeout(() => URL.revokeObjectURL(link.href), 1000); // Revoke after 1 second

    //             return blob_data;
    //         });

    //     });
    // }

    const setIsLoading = async (button_name, is_loading) => {
        setIsLoadingButtonStates((prevStates) => ({
            ...prevStates,
            [button_name]: is_loading
        }));
    }
    const download_file_year = async (year) => {

        setIsLoading(`receipt_${year}_button`, true);

        getAccessToken(instance, accounts).then((response) => {
            let accessToken = response;
            // const ids = [10000];
            // const idString = ids.join(',');
            fetchData(accessToken, `/download_receipt_year?year=${year}`, response => {
                if (!response.ok)
                    throw new Error(`HTTP error! status: ${response.status}`);

                return response.blob();
            }, data => {
                const blob_data = data;
                console.log(blob_data);

                // Create a downloadable link
                // Create a blob URL for the blob
                const blobUrl = URL.createObjectURL(blob_data);
                const link = document.createElement('a');
                link.href = blobUrl;
                link.download = `tax_receipts_${year}.pdf`; // Set default filename if not provided

                // Trigger the download
                link.click();

                // Cleanup the temporary URL (optional)
                setTimeout(() => URL.revokeObjectURL(link.href), 1000); // Revoke after 1 second

                setIsLoading(`receipt_${year}_button`, false);

                return blob_data;
            });

        });
    }
    const download_file_tyl_year = async (year) => {
        getAccessToken(instance, accounts).then((response) => {

            setIsLoading(`thankyou_${year}_button`, true);

            let accessToken = response;
            // const ids = [10000];
            // const idString = ids.join(',');
            fetchData(accessToken, `/download_thank_you_letter_year?year=${year}`, response => {
                if (!response.ok)
                    throw new Error(`HTTP error! status: ${response.status}`);

                return response.blob();
            }, data => {
                const blob_data = data;
                console.log(blob_data);

                // Create a downloadable link
                // Create a blob URL for the blob
                const blobUrl = URL.createObjectURL(blob_data);
                const link = document.createElement('a');
                link.href = blobUrl;
                link.download = `thankyou_letter_${year}.pdf`; // Set default filename if not provided

                // Trigger the download
                link.click();

                // Cleanup the temporary URL (optional)
                setTimeout(() => URL.revokeObjectURL(link.href), 1000); // Revoke after 1 second

                setIsLoading(`thankyou_${year}_button`, false);

                return blob_data;
            });

        });
    }
    const download_file_labels_year = async (year) => {
        getAccessToken(instance, accounts).then((response) => {

            setIsLoading(`label_${year}_button`, true);

            let accessToken = response;
            // const ids = [10000];
            // const idString = ids.join(',');
            fetchData(accessToken, `/download_avery_labels_year?year=${year}`, response => {
                if (!response.ok)
                    throw new Error(`HTTP error! status: ${response.status}`);

                return response.blob();
            }, data => {
                const blob_data = data;
                console.log(blob_data);

                // Create a downloadable link
                // Create a blob URL for the blob
                const blobUrl = URL.createObjectURL(blob_data);
                const link = document.createElement('a');
                link.href = blobUrl;
                link.download = `labels_${year}.pdf`; // Set default filename if not provided

                // Trigger the download
                link.click();

                // Cleanup the temporary URL (optional)
                setTimeout(() => URL.revokeObjectURL(link.href), 1000); // Revoke after 1 second

                setIsLoading(`label_${year}_button`, false);

                return blob_data;
            });

        });
    }

    // const blobToBytes = async (blob) => {
    //     return new Promise((resolve, reject) => {
    //         const reader = new FileReader();
    //         reader.onload = () => {
    //             const arrayBuffer = reader.result;
    //             const bytes = new Uint8Array(arrayBuffer);
    //             resolve(bytes);
    //         };
    //         reader.onerror = (error) => {
    //             reject(error);
    //         };
    //         reader.readAsArrayBuffer(blob);
    //     });
    // };

    const YearButtons = () => {
        if (yearbuttons)
        {
            // console.log(yearbuttons);
            return yearbuttons.map(x => (
                <div key={`yearbutton_${x.Year}`} className="YearBlock">
                    <ButtonSpinner onClick={() => { download_file_year(x.Year); }} label={`Download Tax Receipt ${x.Year}`} isLoading={isLoadingButtonStates[`receipt_${x.Year}_button`]}/>
                    <ButtonSpinner onClick={() => { download_file_tyl_year(x.Year); }} label={`Download Thank You Letter ${x.Year}`} isLoading={isLoadingButtonStates[`thankyou_${x.Year}_button`]}/>
                    <ButtonSpinner onClick={() => { download_file_labels_year(x.Year); }} label={`Download Mail Labels ${x.Year}`} isLoading={isLoadingButtonStates[`label_${x.Year}_button`]}/>
                    <label>Total {x.Count}</label>
                </div>
            ));
            // return <button onClick={download_file}>Placeholder</button>;
        }
        else
            return <></>;
    }

    return (
        <div>
            {/* <div className="pdf-viewport">
                <div className="pdf-container">
                    <Document file={pdfUrl} onLoadSuccess={onLoadSuccess}>
                        <Page pageNumber={pageNumber}
                            renderTextLayer={false}
                            renderAnnotationLayer={false}
                            width={900} />
                    </Document>
                </div>
            </div> */}
            {/* <button onClick={download_file}>Download File</button> */}
            <YearButtons />
        </div>
    );
}